/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseUnitModel>>;
export function request(
  body: defs.basics.BaseUnitRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnit/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
